'use strict';

const Mn = require('backbone.marionette');
const ReadMore = require('common/ui/view/behavior/readmore');
const ItemView = require('data/ui/view/content/item');

module.exports = Mn.CollectionView.extend({
    tagName: 'ul',
    className: 'list',
    childView: ItemView,
    childViewOptions: function() {
        return {
            content: this.getOption('content'),
            context: this.getOption('context')
        };
    },
    behaviors: {
        ReadMore: {
            behaviorClass: ReadMore,
            showReadMore: function() {
                return this.collection.hasNext();
            },
            onReadMore: function() {
                return this.collection.fetchNext(10);
            }
        }
    },

    filter: function(child, index, collection) {
        return !child.isDeleted();
    }
});



// WEBPACK FOOTER //
// ./data/ui/view/content/list.js